"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgKiosk = function SvgKiosk(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M.134 5.39l.87-4.478A1 1 0 012 0h12a1 1 0 01.91.584 1 1 0 01.094.271l.885 4.555a.996.996 0 01.11.64c-.135.815-.48 1.455-1 1.902L15 8v7a1 1 0 01-2 0V8.691c-.103.007-.209.01-.317.01-.975 0-1.774-.268-2.35-.778a2.737 2.737 0 01-.333.252V11a1 1 0 010 2v2a1 1 0 01-1 1H2a1 1 0 01-1-1V8c0-.02 0-.04.002-.06C.489 7.494.149 6.86.014 6.054a.996.996 0 01.12-.665zM2.052 6c.163.503.526.701 1.281.701.827 0 1.181-.236 1.318-.85a1 1 0 011.173-.95 1 1 0 01.837.946c.138.616.495.854 1.322.854.88 0 1.225-.268 1.342-.975a1 1 0 011.006-.837 1 1 0 011.005.834c.12.708.466.978 1.347.978.762 0 1.123-.2 1.281-.713L13.19 2H2.83l-.777 4zM3 8.69V14h5V8.701h-.017c-.96 0-1.75-.26-2.325-.757-.574.497-1.364.757-2.325.757-.113 0-.224-.003-.333-.01z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

SvgKiosk.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgKiosk;
exports.default = _default;